module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":"AmazonCognitoIdentity","commonjs2":"amazon-cognito-identity-js","commonjs":"amazon-cognito-identity-js","amd":"amazon-cognito-identity-js"}
// module id = 2
// module chunks = 0